// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"5314770d67f4a69d","319":"7dcc67e8d2469a35","464":"837862365eb46aa7"}[chunkId] + ".js";
};